"use client";

import { Alert, Box, styled } from "@mui/material";

const Errors = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const ErrorSummary = ({ formError }) => {
  return (
    <Errors>
      {Object.keys(formError).length > 0 && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {Object.entries(formError).map(([_, value], index) => (
            <div key={index}>{value}</div>
          ))}
        </Alert>
      )}
    </Errors>
  );
};

export default ErrorSummary;